module.exports = __webpack_public_path__ + "static/Brand_Data@2x-05661137fbe8844146b1a765cf728923.png";